import { BriefcaseIcon, ShieldCheckIcon } from "@heroicons/react/20/solid";
import type { EpicArea } from "./types";

export type TaskArea = Exclude<EpicArea, "epic">;

/** The built-in task areas every project has besides its epics. Each is stored as a special epic. */
export const TASK_AREAS: Record<TaskArea, { title: string; path: string; description: string; icon: React.ComponentType<{ className?: string }> }> = {
  management: {
    title: "Management",
    path: "management",
    description: "Project management work: planning, client meetings, reporting, coordination and documentation.",
    icon: BriefcaseIcon,
  },
  infra: {
    title: "Infra & Security",
    path: "infra",
    description: "Servers, deployments, monitoring, backups, access control and security work.",
    icon: ShieldCheckIcon,
  },
};

/** Where an epic or task area lives in the app. */
export function epicPath(pid: string, epic: { id: string; area: EpicArea }) {
  return epic.area === "epic" ? `/p/${pid}/epics/${epic.id}` : `/p/${pid}/${TASK_AREAS[epic.area].path}`;
}
